import dunegql from "src/utils/dunegqlCodegen/dunegql";
import {
  useUnpaidInvoicesQuery,
  UnpaidInvoicesQuery,
} from "src/gql/codegen/duneGraphql";
import type { Session } from "src/utils/users/types";
import type { ActiveContext } from "shared/ContextSwitcher/store";

export function useUnpaidInvoices(
  session: Session | undefined,
  activeContext: ActiveContext | undefined
) {
  return useUnpaidInvoicesQuery({
    skip: !session || !activeContext,
    context: { session },
    variables: {
      filters:
        activeContext?.type === "team"
          ? { teamId: { eq: activeContext.id } }
          : {},
    },
  });
}

export function toInvoiceList(data: UnpaidInvoicesQuery) {
  return data?.unpaidInvoices.edges.map((edge) => edge.node);
}

dunegql`
  query UnpaidInvoices($filters: UnpaidInvoicesFiltersInput!) {
    unpaidInvoices(filters: $filters) {
      edges {
        node {
          id
          orbInvoiceId
        }
      }
    }
  }
`;
